
define('text!common/views/commercial/creatives/scrollbg.html',[],function () { return '<div class="ad-scrolling-bg" style="background-image: url(\'<%=backgroundImageP%>\'); background-position: 50% 0; background-repeat: <%=backgroundImagePRepeat%>"></div>\n';});

